/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ type: NonNullable<unknown> }} Seat_Types_Card_ChangeInputs */



/**
* | output |
* | --- |
* | "Change empty {type} seat" |
*
* @param {Seat_Types_Card_ChangeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const seat_types_card_change = /** @type {((inputs: Seat_Types_Card_ChangeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seat_Types_Card_ChangeInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Freien ${i?.type}-Platz ändern`)
	return /** @type {LocalizedString} */ (`Change empty ${i?.type} seat`)
});